export default __webpack_public_path__ + "static/media/company_hero_2.11bcde90.png";